import React from 'react';
import Modal from '../../../components/Modal';

const AddSupplierModal = ({ 
  isOpen, 
  onClose, 
  onSubmit,
  supplierName,
  setSupplierName,
  supplierEmail,
  setSupplierEmail,
  supplierTel,
  setSupplierTel,
  supplierAddress,
  setSupplierAddress,
  supplierFiscal,
  setSupplierFiscal,
  isSubmitting 
}) => {
  // Handle input change locally to prevent focus loss
  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
  };

  // Prevent form submission on Enter key
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Ajouter un nouveau fournisseur"
      onSubmit={onSubmit}
      size="lg"
      isSubmitting={isSubmitting}
      submitLabel="Créer"
    >
      <form id="createSupplierForm" onSubmit={(e) => e.preventDefault()}>
        <div className="space-y-8">
          {/* Basic information */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4 flex items-center">
              <svg className="h-5 w-5 mr-2 text-[#174540]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Informations de base
            </h3>
            
            <div className="space-y-4">
              <div>
                <label htmlFor="supplierName" className="block text-sm font-medium text-gray-700">
                  Nom du fournisseur <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="supplierName"
                  id="supplierName"
                  value={supplierName}
                  onChange={handleInputChange(setSupplierName)}
                  onKeyDown={handleKeyDown}
                  disabled={isSubmitting}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#174540] focus:border-[#174540] sm:text-sm"
                  placeholder="Entrez le nom du fournisseur"
                  autoFocus
                  required
                />
              </div>
              
              <div>
                <label htmlFor="matriculeFiscal" className="block text-sm font-medium text-gray-700">
                  Matricule Fiscal
                </label>
                <input
                  type="text"
                  name="matriculeFiscal"
                  id="matriculeFiscal"
                  value={supplierFiscal}
                  onChange={handleInputChange(setSupplierFiscal)}
                  onKeyDown={handleKeyDown}
                  disabled={isSubmitting}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#174540] focus:border-[#174540] sm:text-sm"
                  placeholder="Entrez le matricule fiscal"
                />
              </div>
            </div>
          </div>

          {/* Contact information */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4 flex items-center">
              <svg className="h-5 w-5 mr-2 text-[#174540]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
              </svg>
              Coordonnées de contact
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="supplierTel" className="block text-sm font-medium text-gray-700">
                  Téléphone
                </label>
                <input
                  type="tel"
                  name="supplierTel"
                  id="supplierTel"
                  value={supplierTel}
                  onChange={handleInputChange(setSupplierTel)}
                  onKeyDown={handleKeyDown}
                  disabled={isSubmitting}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#174540] focus:border-[#174540] sm:text-sm"
                  placeholder="Entrez le numéro de téléphone"
                />
              </div>
              
              <div>
                <label htmlFor="supplierEmail" className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  name="supplierEmail"
                  id="supplierEmail"
                  value={supplierEmail}
                  onChange={handleInputChange(setSupplierEmail)}
                  onKeyDown={handleKeyDown}
                  disabled={isSubmitting}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#174540] focus:border-[#174540] sm:text-sm"
                  placeholder="Entrez l'adresse email"
                />
              </div>
            </div>
            
            <div className="mt-4">
              <label htmlFor="supplierAddress" className="block text-sm font-medium text-gray-700">
                Adresse
              </label>
              <textarea
                name="supplierAddress"
                id="supplierAddress"
                rows="3"
                value={supplierAddress}
                onChange={handleInputChange(setSupplierAddress)}
                disabled={isSubmitting}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#174540] focus:border-[#174540] sm:text-sm"
                placeholder="Entrez l'adresse complète"
              ></textarea>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default AddSupplierModal;